import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SurveyRepositoryImpl } from "../../data/repository/survey_repository_impl";
import { QuestionStatisticsInterface } from "../interfaces/question_stat_interface";

export const useGetSurveyStatistics = (surveyId: string | undefined, enabled: boolean = true) => {
    const repository = new SurveyRepositoryImpl();

    return useQuery<QuestionStatisticsInterface[] | null, AxiosError>({
        queryKey: ['surveyStatistics', surveyId],
        queryFn: () => repository.getSurveyStatistics(surveyId!),
        retry: 4,
        enabled: enabled && !!surveyId,
        staleTime: 5 * 60 * 1000,
        gcTime: 15 * 60 * 1000,
    });
};